var _circle, _line, _line2, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _circle2, _line3, _line4, _line5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 3,
    fill: "#0061ED",
    stroke: "#0061ED",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.5249,
    y1: 35.8145,
    x2: 21.1751,
    y2: 35.8145,
    stroke: "#0061ED",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26.8252,
    y1: 35.8145,
    x2: 32.4754,
    y2: 35.8145,
    stroke: "#0061ED",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 8,
    height: 11,
    rx: 0.941704
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 8,
    height: 11,
    rx: 0.941704,
    fill: "#0061ED",
    stroke: "#0061ED"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 30,
    width: 8,
    height: 11,
    rx: 0.941704
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 30,
    width: 8,
    height: 11,
    rx: 0.941704,
    fill: "#0061ED",
    stroke: "#0061ED"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 5,
    width: 8,
    height: 11,
    rx: 0.941704
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 5,
    width: 8,
    height: 11,
    rx: 0.941704,
    fill: "#0061ED",
    stroke: "#0061ED"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 30,
    width: 8,
    height: 11,
    rx: 0.941704
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 30,
    width: 8,
    height: 11,
    rx: 0.941704,
    fill: "#0061ED",
    stroke: "#0061ED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 3,
    fill: "#0061ED",
    stroke: "#0061ED",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2109,
    y1: 10.6504,
    x2: 20.8612,
    y2: 10.6504,
    stroke: "#0061ED",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5112,
    y1: 10.6504,
    x2: 32.1615,
    y2: 10.6504,
    stroke: "#0061ED",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24.0581,
    y1: 13.0625,
    x2: 24.0581,
    y2: 33.4661,
    stroke: "#0061ED",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default ForwardRef;